import React from 'react';
import DialogContent from '@mui/material/DialogContent';
import { Button, Divider } from '@mui/material';
import AppSimpleDialog from 'app/shared-components/dialogs/AppSimpleDialog';
import { $authHost } from 'app/configs/axiosConfig';
import { useSnackbar } from 'notistack';
import { getAppStage } from '../../../hooks/getAppStage';
import FuseLoading from '@fuse/core/FuseLoading';
import { ModalComponent } from 'app/shared-components/modals/modalManager';

export const numbersByStage = {
  development: '+18668651874',
  staging: '+18668651874',
  production: '+18447311359',
} as const;

export const appStage = getAppStage();
const phoneNumber = numbersByStage[appStage];

export function formatPhoneNumber(phoneNumberString: string) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}

interface NorthCallDialogProps {
  open: boolean;
  handleClose: () => void;
  onSuccess?: () => void;
}

export const NorthCallModal: ModalComponent = ({ open, onClose }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = React.useState(false);

  return (
    <AppSimpleDialog
      open={open}
      handleClose={onClose}
      title="Get a call from Processor"
      titleIcon={
        <img
          className="w-[25px] h-[25px]"
          src="/assets/images/logo/north-icon.svg"
          alt="north-icon"
        />
      }
      size="md"
      maxWidth="sm"
      scroll="paper"
    >
      <Divider />
      <DialogContent className="px-24">
        <div className="p-3 mt-10 flex flex-col items-center relative">
          {loading && (
            <div className="absolute inset-0 bg-white bg-opacity-70 z-20 flex items-center justify-center">
              <FuseLoading />
            </div>
          )}
          <div className="w-[80px] h-[27px] mt-8">
            <img src="/assets/images/logo/north-logo.png" alt="north-logo" />
          </div>

          <h2 className="mt-8 font-bold text-3xl">Speak to someone now!</h2>
          <p className="mt-8 text-center">
            Call us directly at the phone number:{' '}
            <a
              className="blue-primary hover:blue-primary-hover font-[600]"
              href={`tel:${phoneNumber}`}
            >
              {formatPhoneNumber(phoneNumber)}
            </a>{' '}
            below or click the button to request a call.
          </p>
          <div className="mt-30 flex gap-14">
            <Button
              onClick={() => onClose()}
              className="flex items-center text-gray-600 font-500 bg-gray-50 hover:bg-gray-200 px-16 py-8"
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="text-white font-500 bg-blue-primary hover:bg-blue-primary-hover px-16 py-8 disabled:bg-gray-400 disabled:text-opacity-60"
              onClick={() => {
                setLoading(true);
                $authHost
                  .post('/merchant-callback-request')
                  .then((response) => {
                    enqueueSnackbar('Callback request submitted successfully', {
                      variant: 'successToast',
                    });
                  })
                  .catch((error) => {
                    enqueueSnackbar('Failed to submit callback request', {
                      variant: 'errorToast',
                    });
                  })
                  .finally(() => {
                    setLoading(false);
                    onClose();
                  });
              }}
              disabled={loading}
            >
              Request a Callback
            </Button>
          </div>
        </div>
      </DialogContent>
    </AppSimpleDialog>
  );
};
